import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";

class FacebookPixels extends Component {
  state = {
    user_id: localStorage.getItem("user_id"),
    user_role: localStorage.getItem("user_role"),
    facebook_pixel_id: "",
    facebook_pixel_access_token: "",
    test_event_status: 0, // 0 or 1
    test_event_code: "",
    loading: false,
  };

  // Handle text/textarea inputs
  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  // Handle checkbox input
  handleCheckbox = (e) => {
    this.setState({ test_event_status: e.target.checked ? 1 : 0 });
  };

  // Fetch existing pixel data to pre-fill the form
  fetchExistingPixel = async () => {
    const { user_id } = this.state;
    const { user_role } = this.state;
    if (!user_id && !user_role) return;

    try {
      this.setState({ loading: true });
      const res = await axios.get("/get_facebook_pixel", {
        params: { user_id, user_role }, // ✅ pass user_id as query param
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });

      if (res.data.data) {
        this.setState({
          facebook_pixel_id: res.data.data.facebook_pixel_id || "",
          facebook_pixel_access_token: res.data.data.facebook_pixel_access_token || "",
          test_event_status: res.data.data.test_event_status == 1 ? 1 : 0,
          test_event_code: res.data.data.test_event_code || "",
        });
      }
    } catch (err) {
      console.error(err);
    } finally {
      this.setState({ loading: false });
    }
  };

  componentDidMount() {
    this.fetchExistingPixel();
  }

  // Save or Update
  handleSubmit = async (e) => {
    e.preventDefault();
    const { user_id, user_role, facebook_pixel_id, facebook_pixel_access_token, test_event_status, test_event_code } = this.state;

    if (!user_id && !user_role) {
      Swal.fire("Error", "User ID not found", "error");
      return;
    }

    try {
      this.setState({ loading: true });
      const res = await axios.post(
        "/facebook_pixels",
        {
          user_id,
          user_role,
          facebook_pixel_id,
          facebook_pixel_access_token,
          test_event_status,
          test_event_code,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      Swal.fire("Success", res.data.message, "success");
    } catch (err) {
      console.error(err);
      Swal.fire(
        "Error",
        err.response?.data?.message || "Something went wrong",
        "error"
      );
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { facebook_pixel_id, facebook_pixel_access_token, test_event_status, test_event_code, loading } =
      this.state;

    return (
      <div className="pc-container">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="card shadow-sm border-0 rounded-4">
                <div className="card-body p-4">
                  <form onSubmit={this.handleSubmit}>
                    <h4 className="fw-semibold text-uppercase text-center mb-3">Adjust Facebook Pixel with Server Tracking</h4>
                    <p className="fw-semibold text-center mb-3">You can add Facebook Pixel ID and Pixel Access Token</p>
                    <div className="mb-3">
                      <label className="form-label">
                        Facebook Pixel ID <span className="text-danger">*</span>
                      </label>
                      <input
                        type="text"
                        name="facebook_pixel_id"
                        className="form-control"
                        value={facebook_pixel_id}
                        onChange={this.handleChange}
                        required
                      />
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Access Token</label>
                      <textarea
                        name="facebook_pixel_access_token"
                        className="form-control"
                        rows={3}
                        value={facebook_pixel_access_token}
                        onChange={this.handleChange}
                      ></textarea>
                    </div>

                    <div className="form-check mb-3">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={test_event_status === 1}
                        onChange={this.handleCheckbox}
                      />

                      <label className="form-check-label" htmlFor="testEventCheckbox">
                        Enable Test Event
                      </label>
                    </div>

                    <div className="mb-3">
                      <label className="form-label">Test Event Code</label>
                      <input
                        type="number"
                        name="test_event_code"
                        className="form-control"
                        value={test_event_code}
                        onChange={this.handleChange}
                      />
                    </div>

                    <div className="text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        disabled={loading}
                      >
                        {loading ? "Saving..." : "Save"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FacebookPixels;
